import { createSlice } from '@reduxjs/toolkit';

const START_TIME = 60
// const START_TIME = 10

export const slice = createSlice({
  name: 'counter',
  initialState: {
    character: 'yeti',
    gameDuration: 0,
    leaderboard: [],
    paused: null,
    points: 0,
    progress: 0,
    startTime: START_TIME,
    time: START_TIME,
    winner: false,
  },
  reducers: {
    setCharacter: (state, action) => {
      state.character = action.payload;
    },
    setGameDuration: (state, action) => {
      state.gameDuration = action.payload;
    },
    setLeaderboard: (state, action) => {
      state.leaderboard = action.payload;
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    setPaused: (state, action) => {
      state.paused = action.payload;
    },
    setPoints: (state, action) => {
      state.points = action.payload;
    },
    setTime: (state, action) => {
      state.time = action.payload;
    },
    setWinner: (state, action) => {
      state.winner = action.payload;
    },
    setState: (state, action) => {
      // console.log('Action', action.payload)
      return {
        ...state,
        ...action.payload,
      }
    }
  },
});

export const { setGameDuration, setProgress, setPaused, setPoints, setTime, setWinner, setLeaderboard, setState } = slice.actions;

export default slice.reducer;
